/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import {
  useSelector as reduxUseSelector,
  TypedUseSelectorHook,
} from "react-redux";
import { combineReducers } from "redux";

import AdminsReducer from "./AdminsReducer";
import BulkActionReducer from "./BulkActionReducer";
import ContactsReducer from "./ContactsReducer";
import DiscoverReducer from "./DiscoverReducer";
import { EntitiesReducer, LeadershipsReducer } from "./EntitiesReducer";
import { EventsReducer, ActivitiesReducer } from "./EventsReducer";
import ExploreReducer from "./ExploreReducer";
import PackagesReducer from "./PackagesReducer";
import QuotaReducer from "./QuotaReducer";
import ReservationReducer from "./ReservationReducer";
import RolesReducer from "./RolesReducer";
import RoomsReducer from "./RoomsReducer";
import SettingsReducer from "./SettingsReducer";
import StaysReducer from "./StaysReducer";
import { TicketsReducer, TicketTypesReducer } from "./TicketsReducer";
import GroupsReducer from "./UsersReducer";
import VehiclesTypesReducer from "./VehiclesTypesReducer";
import VenuesReducer from "./VenuesReducer";

const allReducers = combineReducers({
  discoverMapCategories: DiscoverReducer,
  events: EventsReducer,
  activities: ActivitiesReducer,
  admins: AdminsReducer,
  groups: GroupsReducer,
  settings: SettingsReducer,
  posts: ExploreReducer,
  venues: VenuesReducer,
  entities: EntitiesReducer,
  leaderships: LeadershipsReducer,
  contacts: ContactsReducer,
  packages: PackagesReducer,
  quotas: QuotaReducer,
  roles: RolesReducer,
  stays: StaysReducer,
  rooms: RoomsReducer,
  reservations: ReservationReducer,
  tickets: TicketsReducer,
  ticketTypes: TicketTypesReducer,
  vehiclesTypes: VehiclesTypesReducer,
  BulkAction: BulkActionReducer,
});

export type RootState = ReturnType<typeof allReducers>;

export const useSelector: TypedUseSelectorHook<RootState> = reduxUseSelector;

export default allReducers;
